import { makeStyles, tokens } from '@fluentui/react-components';

export const useNoAssetCardStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  imageContainer: {
    flexGrow: 1,
    flexBasis: 0,
    maxHeight: '210px',
    width: '100%',
    overflowY: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  gradient: {
    backgroundImage: 'linear-gradient(90deg, #D6E6F0 0%, #F0F3F6 46.5%)',
  },
  image: {
    maxHeight: '148px',
  },
  title: {
    marginTop: '16px',
  },
});

